import * as spacing from 'styles/spacing'
import styled, { keyframes } from 'styled-components'
import { mediaDown, media } from 'styles/media'
import InlineSVG from 'svg-inline-react'

import { buttonBackColor, black } from 'styles/colors'

export const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 25px;
  z-index: 450;
  padding: ${spacing.medium};
  display: flex;
`

// Flash animation

const flashAnimation = keyframes`

  0% { opacity: 0.8; }

  100% { opacity: 0; }

`

// Styled Components

export const CameraOverlay = styled.div`
  position: fixed;

  top: 0;

  left: 0;

  width: 100vw;

  height: 100vh;

  background-color: rgba(0, 0, 0, 0.9);

  z-index: 100; /* Ensures it stays above everything */

  display: flex;

  justify-content: center;

  align-items: center;

  flex-direction: column;
`

export const CameraWrap = styled.div`
  position: relative;

  width: 100vw;

  height: calc(var(--vh, 1vh) * 100);

  display: flex;

  justify-content: center;

  align-items: center;

  overflow: hidden;
`

export const CameraContainer = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
`

export const FlashEffect = styled.div`
  position: absolute;

  width: 100%;

  height: 100%;

  background-color: white;

  opacity: 0.8;

  animation: ${flashAnimation} 0.3s linear forwards;
`

export const Controls = styled.div`
  position: absolute;

  bottom: 8%;

  width: 100%;

  display: flex;

  justify-content: center;

  align-items: center;
  z-index: 110;

  padding: 0 20px;
  ${mediaDown.medium`
      bottom:7%`};
  ${mediaDown.small`
      bottom:7%`};
`

export const CaptureButton = styled.button`
  width: 60px;

  height: 60px;

  background-color: ${buttonBackColor};

  border-radius: 50%;

  border: 5px solid rgba(255, 255, 255, 0.5);

  cursor: pointer;

  transition: transform 0.2s ease-in-out;

  &:hover {
    transform: scale(1.1);
  }

  &:active {
    transform: scale(0.9);
  }
  ${mediaDown.xLarge`
    width: 65px;
    height: 65px;`};
  ${mediaDown.large`
      width: 60px;
    height: 60px;`};
`

export const RectangleOverlay = styled.div`
  position: absolute;

  top: 50%;

  left: 50%;

  width: 60%;

  height: 20%;

  transform: translate(-50%, -50%);

  border: 4px dashed #4caf50;

  border-radius: 10px;

  display: flex;

  justify-content: center;

  align-items: center;

  &::after {
    display: block;
    content: '${(props) => props.contentText || ''}';

    color: white;

    font-size: 18px;

    font-weight: bold;
  }
  ${mediaDown.small`width: 90%;
      height: 65%;`};
`

export const Logo = styled(InlineSVG)`
  fill: ${black};
  width: 104px;
  margin: 0 auto;
  cursor: ${(props) => (props.isdisabled ? 'not-allowed' : 'pointer')};

  ${media.medium`
    width: 114px;

  `};

  ${media.large`
    width: 136px;
   
  `};
`

export const SwitchCameraButton = styled.button`
  margin-left: 10%;
  width: 60px;

  height: 60px;

  background-color: ${buttonBackColor};

  border-radius: 50%;

  border: 5px solid rgba(255, 255, 255, 0.5);

  cursor: pointer;

  transition: transform 0.2s ease-in-out;

  &:hover {
    transform: rotate(90deg) scale(1.05);
  }

  &:active {
    transform: scale(0.95);
  }
  ${mediaDown.xLarge`
    width: 65px;
    height: 65px;`};
  ${mediaDown.large`
      width: 60px;
    height: 60px;`};

  svg {
    width: 28px;
    height: 28px;
    fill: #333;
  }
`

export const ControlWrapDiv = styled.div`
width:50%;
justify-content:start:
`
export const Tooltip = styled.div`
  position: relative;
  display: inline-block;
  cursor: pointer;
  &:hover {
    .tooltip-text {
      visibility: visible;
    }
  }
`
export const TooltipText = styled.span`
  visibility: hidden;
  opacity: 1;
  width: max-content;
  background-color: #333;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 6px 10px;
  position: absolute;
  z-index: 1;
  bottom: -30%; /* Show above the element */
  left: -15%;
  transform: translateX(-50%);

  transition: opacity 0.3s;

  /* Arrow */
  &::after {
    content: '';
    position: absolute;
    bottom: 103%;
    right: 19%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent #333 transparent;
  }
`
